// "use client";

// import React, { useEffect, useState } from "react";
// import { RefreshCcw } from "lucide-react";
// import { useLoader } from "../../_helper/LoaderContext";
// import { useLab } from "../../_helper/PharmacyProvider";
// import { getProfileData } from "../LabProfile/service/profile-service";
// import { updateConvertionRate } from "./service/setting-service";
// import { toast } from "react-toastify";
// import { Card, Col, Container, Row } from "reactstrap";
// import { Breadcrumbs } from "../../AbstractElements";

// export default function ChangeAmount() {
//   const { setLoading } = useLoader();
//   const { currentLab, setCurrentLab } = useLab()

//   const [conversionRates, setConversionRates] = useState({
//     // USD: 84,
//     // INR: 1,
//     // EUR: 104,
//   });

//   useEffect(() => {
//     getData()
//   }, [])

//   const getData = async () => {
//     setLoading(true);
//     try {
//       const res = await getProfileData();
//       if (res.data.success == true) {
//         setConversionRates(res.data.data.conversionRates)
//       }
//     } catch (error) {
//       console.log(error);
//     } finally {
//       setLoading(false)
//     }
//   }

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setConversionRates({ ...conversionRates, [name]: Number(value) });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     // console.log("Updated Rates:", conversionRates);
//     setLoading(true)
//     try {
//       const payload = {
//         conversionRates: conversionRates
//       }
//       const res = await updateConvertionRate(payload);
//       if (res.data.success == true) {
//         toast.success(res.data.message);
//         localStorage.setItem("currentLab", JSON.stringify(res.data.data))
//         setCurrentLab(res.data.data)
//       }
//     } catch (error) {
//       console.log(error);
//     } finally {
//       setLoading(false)
//     }
//   };

//   return (
//     <>
//       <Breadcrumbs mainTitle="Conversion Setting" parent="Home" title="Conversion Setting" />
//       <Container fluid={false}>
//         <Row>
//           <Col>
//             <Card>
//               <div className="tw-p-4 tw-transform tw-transition-all">
//                 <div className="tw-text-center tw-mb-6">
//                   <h2 className="tw-text-3xl tw-font-bol">
//                     Conversion Rates
//                   </h2>
//                   <p className="tw-text-gray-500 tw-mt-1">
//                     Manage currency conversion values easily
//                   </p>
//                 </div>

//                 <form onSubmit={handleSubmit} className="tw-space-y-5">
//                   <div className="row">
//                     {Object.keys(conversionRates).map((key) => (
//                       <div className="col-md-4">
//                         <div
//                           key={key}
//                           className="tw-group tw-bg-white tw-border tw-border-gray-200 tw-rounded-xl tw-p-2 tw-shadow-sm hover:tw-shadow-lg tw-transition-all tw-duration-300"
//                         >
//                           <label className="tw-text-sm tw-font-semibold tw-text-gray-600">
//                             {key} Rate
//                           </label>

//                           <div className="tw-flex tw-items-center tw-mt-1">
//                             <input
//                               type="number"
//                               name={key}
//                               value={conversionRates[key]}
//                               onChange={handleChange}
//                               className="form-control"
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     ))}
//                   </div>

//                   <div className="tw-flex tw-justify-end">
//                     <button
//                       type="submit"
//                       className="btn btn-primary"
//                     >
//                       Update Rates
//                     </button>
//                   </div>
//                 </form>

//                 <p className="tw-text-center tw-text-xs tw-text-gray-500 tw-mt-5">
//                   Your changes will take effect immediately
//                 </p>

//               </div>
//             </Card>
//           </Col>
//         </Row>
//       </Container>
//     </>
//   );
// }


import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLoader } from "../../_helper/LoaderContext";
import { useLab, usePharmacy } from "../../_helper/PharmacyProvider";
import { Breadcrumbs } from "../../AbstractElements";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { DollarSign, Clock } from "react-feather";
import { toast } from "react-toastify";
import { updateConvertionRate } from "./service/setting-service"


const ChangeAmount = () => {
  const { t } = useTranslation();
  const { setLoading } = useLoader();
  const { currentLab, setCurrentLab } = useLab();

  const [conversionRates, setConversionRates] = useState({});
  const [expiryAlertDays, setExpiryAlertDays] = useState("");

  const baseCurrency = currentLab?.baseCurrency || "INR";
  const allowedCurrencies = currentLab?.allowedCurrencies || [];

  /* ---------- INIT ---------- */
  useEffect(() => {
    if (currentLab) {
      setConversionRates(currentLab.conversionRates || {});
      setExpiryAlertDays(currentLab.expiry_alert_duration || "");
    }
  }, [currentLab]);

  /* ---------- HANDLERS ---------- */
  const handleRateChange = (currency, value) => {
    setConversionRates(prev => ({
      ...prev,
      [currency]: parseFloat(value) || 0
    }));
  };

  const saveConversionRates = async () => {
    setLoading(true);
    try {
      // const payload = { conversionRates };
      const payload = {
        conversionRates: conversionRates
      }
      const res = await updateConvertionRate(payload);

      if (res.data.success == true) {
        toast.success(res.data.message);
        localStorage.setItem("currentLab", JSON.stringify(res.data.data))
        setCurrentLab(res.data.data)
      }
    } catch (err) {
      toast.warning(t("Failed to update conversion rates"));
    } finally {
      setLoading(false);
    }
  };

  const saveExpiryAlert = async () => {
    if (!expiryAlertDays || expiryAlertDays <= 0) {
      toast.info(t("Please enter valid expiry alert duration"));
      return;
    }

    setLoading(true);
    try {
      const payload = { expiry_alert_duration: Number(expiryAlertDays) };
      const res = await updateConvertionRate(payload);

      if (res.data.status === "success") {
        toast.success(t("Expiry alert duration updated"));
        localStorage.setItem("currentPharmacyPOS", JSON.stringify(res.data.data));
        setCurrentLab(res.data.data);
      }
    } catch (err) {
      toast.warning(t("Failed to update expiry alert"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Breadcrumbs
        mainTitle={t("Conversion Settings")}
        parent={t("Dashboard")}
        title={t("Conversion Settings")}
      />
      <Container fluid={true}>
        <Row>
          {/* ================= Currency Conversion ================= */}
          <Col md="6">
            <div className="card border-light p-3">
              <div className="card-body">
                <h5 className="fw-bold mb-3">
                  {t("Currency Conversion Rates")}
                </h5>

                <p className="text-muted">
                  {t("Base Currency")}: <strong>{baseCurrency}</strong>
                </p>

                <Row className="g-3 align-items-center">
                  {allowedCurrencies.map(currency => {
                    if (currency === baseCurrency) return null;

                    return (
                      <Col md="12" key={currency}>
                        <label className="form-label fw-semibold">
                          {currency}
                        </label>
                        <div className="input-group">
                          <span className="input-group-text">
                           1 {baseCurrency} =
                          </span>
                          <input
                            type="number"
                            min="0"
                            step="0.01"
                            value={conversionRates[currency]  ?? ""}
                            onChange={(e) =>
                              handleRateChange(currency, e.target.value)
                            }
                            className="form-control"
                          />
                          <span className="input-group-text">
                            {currency}
                          </span>
                        </div>
                      </Col>
                    );
                  })}
                </Row>

                <div className="text-end mt-4">
                  <button
                    className="btn btn-primary"
                    onClick={saveConversionRates}
                  >
                    {t("Save Conversion Rates")}
                  </button>
                </div>
              </div>
            </div>
          </Col>
        </Row>

      </Container>

    </>
  );
};

export default ChangeAmount;